import React from "react";
import { connect } from 'react-redux';
import UserRoleComponent from './UserRoleComponent';
import { AssignRolesToUser, RemoveUserFromRole } from 'helpers/api-calls/role-calls';
import { teamProfileOperations } from './duck';
import { appOperations } from 'App/duck';

const mapStateToProps = ({ locationReducer, appReducer }) => ({
  locationId: locationReducer.location_code,
  roles: appReducer.roles.data,
});

const mapDispatchToProps = (dispatch) => ({

   loadLocationRolesDispatch:  (locationId) => {
       dispatch(appOperations.fetchLocationRolesOperation(locationId));
   },

  removeRoleFromUserDispatch: (userId, roleId, userRoleIds, locationId, userPrivilegeId) => {
    RemoveUserFromRole(userId, userRoleIds || [], [roleId], locationId)
      .then(() => {
        dispatch(teamProfileOperations.getUserProfileOperation(locationId, userPrivilegeId));
      });
  },
  addRoleToUserDispatch: (userId, roleId, userRoleIds, locationId, userPrivilegeId) => {
    const updatedRoleIds = Array.from(new Set([...(userRoleIds || []), roleId]));
    AssignRolesToUser(userId, updatedRoleIds, locationId)
      .then(() => {
        dispatch(teamProfileOperations.getUserProfileOperation(locationId, userPrivilegeId));
      });
  }
});

const UserRoleContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserRoleComponent);

export default UserRoleContainer;
